// extracted by mini-css-extract-plugin
export default {"info":"OpcYp","spinner":"kjgXb","instruction":"DX7gK"};